var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("해외미술품 구매대행")])]), _c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("해외미술품 구입의 애로점")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "page-text primary--text"
  }, [_c('p', [_vm._v("해외미술품 구입은 소장처 조사, 인보이스, 매매계약, 송금, 운송 등 많은 절차와 수고로움이 필요합니다.")]), _c('p', [_vm._v("또한, 일정의 준수, 구입비용의 정산, 작품상태의 유지 등 여러 측면에서 거래의 안전성이 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("매우 요구됩니다.")]), _c('p', [_vm._v("개인 혹은 기업에서 여러 번 반복하여 미술품을 수입하는 경우, 세무당국의 오해를 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("받을 수 있습니다.")])])])], 1)], 1)]), _c('v-divider', {
    staticClass: "grey-cb"
  }), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-20 mb-md-40"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("구매대행 프로세스")])]), _c('div', [_c('v-img', {
    attrs: {
      "src": "/images/sub/service/service-museum-img.png"
    }
  })], 1)]), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-20 mb-md-40"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("캐터 옥션의 강점")])]), _c('div', {
    staticClass: "my-n14 my-md-n20"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-museum-img2.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v("풍부한 노하우")])]), _c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("캐터옥션은 해외 미술품을 수입, 구매해 온 최고의 노하우를 보유하고 있습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("캐터옥션을 통하여, 고객의 시간과 노력, 비용을 절감할 수 있습니다.")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-museum-img3.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v("거래의 안전성 및 보안성 유지")])]), _c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("작품은 최상의 상태로, 고객에게 안전하게 전달됩니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("당사는 해외 소재의 보험업체, 포장업체, 운송업체 등과의 광범위한 네트워킹을 통하여, 각종 변수와 리스크를 최소화시키면서, 해외 비지니스를 최대한 안전하게 진행합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("해외 수입에 따른, 수많은 단계와 절차 속에서, 고객의 익명성(anonymity), 보안성을 유지합니다. ")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-museum-img4.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v("높은 가격 경쟁력 및 신속한 구매 처리")])]), _c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("가격 조사 및 네고(Negotiation), 복수견적 등을 통하여 작품 원가를 절감합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("각 단계마다 발생하는 물류비를 절감하여 드립니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("작품원가 및 물류비 절감을 통하여, 국내보다는 저렴한 가격으로 구입할 수 있습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("숙달된 노하우, 해외의 광범위한 네트워킹을 통하여 작품구입을 신속하게 진행합니다.")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-museum-img5.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v("체계적인 문서화 작업")])]), _c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("진품보증서, 상태검사서, 작품이력서, 전시도록, 참고문헌, 설치방법서 등 작품의 진품성과 부가가치에 기여하는 중요한 자료들을 꼼꼼히 챙겨서 고객에게 일괄 전달합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("인보이스, 매매계약서, 송금신청서, 보험가입신청서, 수입면장 등 작품수입과 관련된 중요 문서들을 고객에게 일괄 전달 합니다.")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])])], 1)], 1)])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }